module.exports = __webpack_public_path__ + "img/yb9.05980385.jpg";